// modified by Marvin

class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(
        this.handleIntersection.bind(this),
        {
          rootMargin: '0px 0px 200px 0px'
        }
      ).observe(this);
    }
  }

  onClickHandler() {
    if (
      this.classList.contains('loading') ||
      this.classList.contains('disabled')
    ) return;

    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();

    sections.forEach(() => {
      const url = this.dataset.url;
      InfiniteScroll.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ];
  }

  static async renderSectionFromFetch(url) {
    try {
      const response = await fetch(url);
      const html = await response.text();

      InfiniteScroll.renderPagination(html);
      await InfiniteScroll.renderProductGridContainer(html);

    } catch (e) {
      console.error('Infinite scroll error:', e);
    }
  }

  static renderPagination(html) {
    const container = document
      .getElementById('ProductGridContainer')
      .querySelector('.pagination-wrapper');

    const pagination = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer')
      .querySelector('.pagination-wrapper');

    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    } else {
      container.remove();
    }
  }

  static async renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');

    const products = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-grid');

    // 1. Insert the new products
    container.insertAdjacentHTML('beforeend', products.innerHTML);

    try {
      // 2. Collect product handles and fetch RFQ product data
      if (
        window.GRFQApp &&
        typeof GRFQApp.collectProductsOnPage === 'function'
      ) {
        await GRFQApp.collectProductsOnPage();
      }

      // 3. Create RFQ buttons for newly loaded products
      if (
        window.GRFQApp &&
        typeof GRFQApp.initProductList === 'function'
      ) {
        await GRFQApp.initProductList();
      }

    } catch (error) {
      console.error(
        'RFQ infinite scroll initialization failed:',
        error
      );
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
